export class ApiErrorDetails {
    statusCode: number;
    statusText: string;
    userMessage: string;
    detailedMessage: string;
}